<template>
    <v-app ref="app">
            <TestModule v-if="currentModule ==='TestModule'" ref="TestModule"/>
            <HelpModule v-if="currentModule ==='HelpModule'" ref="HelpModule"/>
            <QBModule v-if="currentModule ==='QBModule'" ref="QBModule"/>
            <EMModule v-if="currentModule ==='EMModule'" ref="EMModule"/>
            <FormModule v-if="currentModule ==='FormModule'" ref="FormModule"/>
            <DashboardModule v-if="currentModule ==='DashboardModule'" ref="DashboardModule"/>
            <SurveyStatsModule v-if="currentModule ==='SurveyStatsModule'" ref="SurveyStatsModule"/>
            <ReportTypeModule v-if="currentModule ==='ReportTypeModule'" ref="ReportTypeModule"/>
            <AssessmentStatsModule v-if="currentModule ==='AssessmentStatsModule'" ref="AssessmentStatsModule"/>
            <KioskModule v-if="currentModule ==='KioskModule'" ref="KioskModule"/>
            <SupersetModule v-if="currentModule ==='SupersetModule'" ref="SupersetModule"/>
            <CustomersModule v-if="currentModule === 'CustomersModule'" ref="CustomersModule"/> 
            <AISearchModule v-if="currentModule === 'AISearchModule'" ref="AISearchModule"/> 
            <ProjectCalendarModule v-if="currentModule === 'ProjectCalendarModule'" ref="ProjectCalendarModule"/>
						<DialogManager ref="DialogManager" v-on:refresh="refreshModule"/> 
            <PayrollPreviewModule v-if="currentModule === 'PayrollPreviewModule'" ref="PayrollPreviewModule"/>
            <AddCalendarHolidaysDialog v-if="currentModule === 'AddCalendarHolidaysDialog'" ref="AddCalendarHolidaysDialog"/>
            <ComplaintConfigModule v-if="currentModule === 'ComplaintConfigModule'" ref="ComplaintConfigModule"/>
            <ExpenseSheetDetailDialog v-if="currentModule === 'ExpenseSheetDetailDialog'" ref="ExpenseSheetDetailDialog"/>
            <UpgradeLicenseDialog v-if="currentModule === 'UpgradeLicenseDialog'" ref="UpgradeLicenseDialog"/>
            <PurchaseLicenseItemDialog v-if="currentModule === 'PurchaseLicenseItemDialog'" ref="PurchaseLicenseItemDialog"/>
            <ManageCalendarRulesDialog v-if="currentModule === 'ManageCalendarRulesDialog'" ref="ManageCalendarRulesDialog"/>
    </v-app>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import TestModule from './components/modules/TestModule'
import HelpModule from './components/modules/HelpModule'
import QBModule from './components/modules/QBModule'
import EMModule from './components/modules/EMModule'
import DashboardModule from './components/modules/DashboardModule'
import FormModule from './components/modules/FormModule'
import SurveyStatsModule from './components/modules/SurveyStatsModule'
import ReportTypeModule from './components/modules/ReportTypeModule'
import AssessmentStatsModule from './components/modules/AssessmentStatsModule'
import KioskModule from './components/modules/KioskModule'
import SupersetModule from './components/modules/SupersetModule'
import CustomersModule from './components/modules/CustomersModule'
import DialogManager from './components/modules/DialogManager'
import AISearchModule from './components/modules/AISearchModule'
import ProjectCalendarModule from './components/modules/ProjectCalendarModule'
import PayrollPreviewModule from './components/modules/PayrollPreviewModule'
import AddCalendarHolidaysDialog from './components/modules/dialogs/AddCalendarHolidaysDialog'
import ComplaintConfigModule from './components/modules/ComplaintConfigModule'
import ExpenseSheetDetailDialog from './components/modules/dialogs/ExpenseSheetDetailDialog'
import UpgradeLicenseDialog from './components/modules/dialogs/license/UpgradeLicenseDialog'
import PurchaseLicenseItemDialog from './components/modules/dialogs/license/PurchaseLicenseItemDialog'
import ManageCalendarRulesDialog from './components/modules/dialogs/ManageCalendarRulesDialog'

import { EventBus }  from './components/util/event-bus'
import gwt from './api/gwt'

export default {
  name: 'App',
  components: {
    DialogManager, TestModule, HelpModule, QBModule, ReportTypeModule,FormModule, SurveyStatsModule,AssessmentStatsModule, 
		KioskModule, CustomersModule, EMModule, DashboardModule, AISearchModule, ProjectCalendarModule, PayrollPreviewModule,
		AddCalendarHolidaysDialog, SupersetModule, ComplaintConfigModule, ExpenseSheetDetailDialog, UpgradeLicenseDialog,
    PurchaseLicenseItemDialog, ManageCalendarRulesDialog
  },

  data () {
      return { 
          currentModule: 'TestModule'
      }
    },
  mounted: function ()  {
      let me = this;
      this.$nextTick(() => {
            window.$vueBridge = me;
            me.$refs.app.$el.firstChild.style.minHeight="100%";
    });
      
    EventBus.$on('widget-data-click',payload => {
        if (payload.mode==='VUEDIALOG') {
          me.$refs.DialogManager.processEvent( payload.mode, payload.type,payload.action,payload.payload, payload.eventConfig);
        } else {
          gwt.processEvent( payload.mode, payload.type,payload.action,payload.payload);
        }
      });
  },
  methods: {
    getCurrentModule() {
        return this.currentModule;
    },
    refreshModule() {
      if (this.currentModule && this.$refs[this.currentModule] && this.$refs[this.currentModule].refreshModule) {
        this.$refs[this.currentModule].refreshModule();
      }
    },
    showModule(module,payload) {
        let me = this;
        me.currentModule = module;
        this.$nextTick(() => {
						if (me.$refs[module] && me.$refs[module].onReveal) {
								me.$refs[module].onReveal(payload);
						}
        });
    },
    hideModule(module) {
        let me = this;
        this.$nextTick(() => {
						if (me.$refs[module] && me.$refs[module].close) {
								me.$refs[module].close();
						}
        });
    }
  }
}
</script>
